<script setup>
import { computed } from 'vue';
import { t } from '../i18n';

const props = defineProps({
	query: { type: String, default: '' },
});

const searchMessage = computed(() => t.noDealersNear(props.query || t.yourSearch));
</script>

<template>
	<div class="dealer-locator__empty empty-locator">

		<div class="empty-locator__header">
			<span class="empty-locator__icon" aria-hidden="true"></span>
			<svg class="empty-locator__icon-old" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" viewBox="0 0 120 120">
				<g fill="#fefefe" clip-path="url(#clip0_210_2261)">
					<path
						d="M62.5 108.7c1.1-.1 1.2 0 1.9.7v4.3q-.2.6-.8 1c-1 .1-1.3 0-1.8-.8v-4q0-.9.7-1.2M56.3 108.6c1 0 1.2 0 1.8 1v4.2q-.2.5-.8.9c-2 .2-2-1-1.8-2.7 0-1.6-.6-2.3.8-3.4M59.3 87.4c1.7-.2 5.2.3 6.9.7 3.2.9 7.4 3 9.9 5.3l.8 1.2c0 2-1 3.7-3.3 3-.5 0-1.7-1-2.3-1.4a20 20 0 0 0-10.6-3.6 21 21 0 0 0-12.3 3.6c-.9.5-1.6 1.5-2.7 1.6-2.5.3-3.7-2.8-2-4.5 1.6-1.5 4-2.7 5.9-3.6q4.5-2.3 9.7-2.3M30.2 76.4c1 .4 3.5 7 3.6 8.1q.3 4-3.5 4.6c-1.9-.1-3.5-1.3-3.6-3.2-.2-2.6 2-7.6 3.5-9.5M92.3 35l.3.3v.1c-.5.7-2.1 2.1-2.8 2.8q-.1 0-.3-.2c0-.4 2.3-2.5 2.8-3M95.8 35q.2.1.3.4l-2.8 2.8q-.4-.1-.3-.4zM99.3 35q.3.2.3.4c-.3.5-2.2 2.3-2.7 2.8q-.1 0-.3-.3c0-.4 2.2-2.3 2.7-2.8" />
					<path fill-rule="evenodd"
						d="m98.8 0 9.2 9.2v39.2h2.7c.6.8 1.8 2 2.6 2.7v20.6l-2.6 2.6h-5.4v28L93 114.4l-3.8 4q-6.6-.1-13 0l-1 1.6H44.5q-.4-.9-1-1.6c-.2-.2-11.5-.1-12.7-.1l-16.2-16v-28H9.3l-2.6-2.6V51.4l2.6-2.7h2.8V9.2L21.3 0zM72 104.7c-4.8-.1-9.7-.5-14.4-.4l-9.6.4-2.4 8.5-1.5 5.3.6 1h30.4l.6-1-2.4-9.1zm32.7-57.5h-4.1v18.5l-6.7 6.6H79.5q-4.4 0-8.7 0l-6-5.6-.6-5.7-.4-3.9H56l-1 9.5-6 5.8H26L23.6 70l-4.6-4.4V47.2h-3.8v21.1l2-1.2c.8.9 6.1 5.8 6.2 6.2v.2c-.6 0-2-1.5-2.4-2L17 67.7l-1.9 1.1V102L31 117.8c4.1 0 8.7.1 12.8 0 .5-1.8 3.4-12.8 4-13.4.9-.3 3-.3 4.1-.4q8.2-.4 16.5 0c.8.1 3 .1 3.7.3.5.2 1.8 5.3 2 5.8l2 7.8h13q7.6-8 15.7-15.8V68.8l-1.8-1-3.8 3.7c-.4.4-1.8 2-2.3 2l-.2-.2c.4-.6 5.4-5.4 6.2-6.1l1.8 1zm-95.2 2-2.3 2.4v20l2.3 2.3h4.9V49.2zm95.8-.3v25h5.2l1-1.2 1.3-1.2V51.3l-2.4-2.4zM20 47.8v17.3l6.7 6.3h21.9c2-1.9 3.3-3.5 5.2-5.2.4-3 1-7 1.2-10h10l1.1 10 5 4.8h22.7l5.9-6V47.9zm-7.3-5.6v6.5h2v-2l.5-.6 2.9-3.9zm95 0H102l3.1 4.6v1.6h2.3zm-89 0-3.4 4.6h89.5l-3.3-4.6zm87.7-4.3q-.3 1.9-.9 3.8h2.1v-3zm-93.7 3.8H105l.2-.8.7-3.3q-4-3-7.9-6.2H12.6zM70.1.5v5.7H50V.5H21.4l-8.8 8.9v21.5h85.5q3.7 3 7.6 5.9l1.8 1.4V9.4L98.6.5zM50.5.5v5.2h19V.4z"
						clip-rule="evenodd" />
				</g>
				<defs>
					<clipPath id="clip0_210_2261">
						<path fill="#fff" d="M0 0h120v120H0z" />
					</clipPath>
				</defs>
			</svg>
			<h2 class="empty-locator__title">{{ t.noDealersFound }}</h2>
			<p class="empty-locator__text">{{ searchMessage }}</p>
		</div>

		<div class="empty-locator__info">
			<p class="empty-locator__hint">{{ t.tryTheseSteps }}</p>
			<ul class="empty-locator__list">
				<li>{{ t.checkSpelling }}</li>
				<li>{{ t.expandRadius }}</li>
			</ul>
		</div>

	</div>
</template>
